import { placesInTime, type TimedSlide } from './timeline';

/**
 * Direction B (beta only): the still a paused stage shows at the start of a scene. The player draws a scene it jumps to
 * (on load, or a pick while paused) at its last frame while the clock reads the scene's start, and a scene that fades
 * in or wipes out after its last word then shows an empty stage; the scene's stored preview shows it instead.
 */
export function stagePoster(
  state: { isPlaying: boolean; currentTime: number; currentSlideId: string },
  manifest: { slides: TimedSlide[] } | null,
  stillOf: (sceneId: string) => string | undefined,
): string | null {
  if (state.isPlaying || !state.currentSlideId) return null;
  const place = placesInTime(manifest).get(state.currentSlideId);
  if (!place || Math.abs(state.currentTime - place.start) > 0.05) return null;
  return stillOf(state.currentSlideId) ?? null;
}
